import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthTokenService {
  private tokenSubject = new BehaviorSubject<{ access_token: string } | null>(null);

  getTokenSubject() {
    return this.tokenSubject;
  }

  setToken(token: { access_token: string } | null) {
    this.tokenSubject.next(token);
  }
}
